export default __webpack_public_path__ + "static/media/zdjChorw3.0cc7e130.jpg";